const headerComponent = document.getElementsByClassName('header')[0];

if (headerComponent && headerComponent.dataset.headerInit !== 'true') {
  headerComponent.dataset.headerInit = 'true';

  const dropdownItems = headerComponent.querySelectorAll('.menu-item.dropdown');
  const dropdownToggles = headerComponent.querySelectorAll('.dropdown-toggle');
  const burgerBtn = headerComponent.querySelector('.burger-btn');
  const menuToggle = headerComponent.querySelector('.menu-toggle');
  const navbarNav = headerComponent.querySelector('.navbar-nav');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');
  const dropdownVisibleClass = 'is-visible';
  const getMobileMenuStartPoint = () => {
    const breakpoint = Number.parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        '--mobile-menu-start-point'
      ),
      10
    );

    return Number.isNaN(breakpoint) ? 1200 : breakpoint;
  };
  const isMobileMenuMode = () =>
    window.innerWidth <= getMobileMenuStartPoint() ||
    headerComponent.classList.contains('header-mobile') ||
    Boolean(document.querySelector('.header-mobile'));
  let wasMobileMenuMode = isMobileMenuMode();
  let desktopDropdownCloseTimeout = null;

  const getScrollLock = () =>
    typeof scrollLock !== 'undefined' ? scrollLock : null;

  const setBurgerExpanded = (isExpanded) => {
    burgerBtn?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  };

  const closeDropdown = (item) => {
    const dropdownMenu = item?.querySelector('.dropdown-menu');

    item?.classList.remove('active');

    if (!dropdownMenu) {
      return;
    }

    dropdownMenu.style.maxHeight = '0px';
    dropdownMenu.style.opacity = '0';
    dropdownMenu.style.removeProperty('display');
    dropdownMenu.classList.remove(dropdownVisibleClass);
  };

  const resetDropdown = (item) => {
    const dropdownMenu = item?.querySelector('.dropdown-menu');

    item?.classList.remove('active');

    if (!dropdownMenu) {
      return;
    }

    dropdownMenu.style.removeProperty('display');
    dropdownMenu.style.removeProperty('max-height');
    dropdownMenu.style.removeProperty('opacity');
    dropdownMenu.classList.remove(dropdownVisibleClass);
  };

  const clearDropdownState = () => {
    dropdownItems.forEach((item) => {
      closeDropdown(item);
    });
  };

  const resetDropdownState = () => {
    dropdownItems.forEach((item) => {
      resetDropdown(item);
    });
  };

  const openDropdown = (item, dropdownMenu) => {
    item.classList.add('active');
    dropdownMenu.style.maxHeight = `${dropdownMenu.scrollHeight}px`;
    dropdownMenu.style.opacity = '1';
    dropdownMenu.classList.add(dropdownVisibleClass);
  };

  const updateActiveDropdownHeights = () => {
    dropdownItems.forEach((item) => {
      const dropdownMenu = item.querySelector('.dropdown-menu');

      if (!dropdownMenu || !item.classList.contains('active')) {
        return;
      }

      dropdownMenu.style.maxHeight = `${dropdownMenu.scrollHeight}px`;
    });
  };

  const cancelDesktopDropdownClose = () => {
    if (!desktopDropdownCloseTimeout) {
      return;
    }

    window.clearTimeout(desktopDropdownCloseTimeout);
    desktopDropdownCloseTimeout = null;
  };

  const showDesktopDropdown = (item) => {
    const dropdownMenu = item?.querySelector('.dropdown-menu');

    if (!dropdownMenu || isMobileMenuMode()) {
      return;
    }

    cancelDesktopDropdownClose();

    dropdownItems.forEach((dropdownItem) => {
      if (dropdownItem !== item) {
        resetDropdown(dropdownItem);
      }
    });

    item.classList.add('active');
    dropdownMenu.style.removeProperty('max-height');
    dropdownMenu.style.removeProperty('opacity');
    dropdownMenu.style.display = 'block';

    window.requestAnimationFrame(() => {
      dropdownMenu.classList.add(dropdownVisibleClass);
    });
  };

  const hideDesktopDropdown = (item) => {
    const dropdownMenu = item?.querySelector('.dropdown-menu');

    if (!dropdownMenu) {
      return;
    }

    item.classList.remove('active');
    dropdownMenu.classList.remove(dropdownVisibleClass);

    window.setTimeout(() => {
      if (!item.classList.contains('active')) {
        dropdownMenu.style.removeProperty('display');
      }
    }, 240);
  };

  const scheduleDesktopDropdownClose = (item) => {
    if (isMobileMenuMode()) {
      return;
    }

    cancelDesktopDropdownClose();
    desktopDropdownCloseTimeout = window.setTimeout(() => {
      hideDesktopDropdown(item);
    }, 120);
  };

  const lockPageScroll = () => {
    const pageScrollLock = getScrollLock();

    if (!pageScrollLock?.disablePageScroll) {
      window.lenis?.stop();
      return;
    }

    const menuScrollTarget = navbarNav?.querySelector('.menu');

    if (menuScrollTarget) {
      pageScrollLock.disablePageScroll(menuScrollTarget);
    } else {
      pageScrollLock.disablePageScroll();
    }

    pageScrollLock.addScrollableSelector?.('.simplebar-content-wrapper');
    window.lenis?.stop();
  };

  const unlockPageScroll = () => {
    const pageScrollLock = getScrollLock();

    pageScrollLock?.enablePageScroll?.();
    window.lenis?.start();
  };

  const isMenuOpen = () =>
    headerComponent.classList.contains('is-open-menu') ||
    Boolean(navbarNav?.classList.contains('active')) ||
    Boolean(headerCloseWrapper?.classList.contains('active'));

  const openMenu = () => {
    if (!isMobileMenuMode()) {
      return;
    }

    headerComponent.classList.add('is-open-menu');
    burgerBtn?.classList.add('active');
    menuToggle?.classList.add('active');
    navbarNav?.classList.add('active');
    headerCloseWrapper?.classList.add('active');
    setBurgerExpanded(true);
    lockPageScroll();
    updateActiveDropdownHeights();
  };

  const closeMenu = ({ resetDropdownStyles = false } = {}) => {
    const wasMenuOpen = isMenuOpen();

    headerComponent.classList.remove('is-open-menu');
    burgerBtn?.classList.remove('active');
    menuToggle?.classList.remove('active');
    navbarNav?.classList.remove('active');
    headerCloseWrapper?.classList.remove('active');
    setBurgerExpanded(false);

    if (resetDropdownStyles) {
      resetDropdownState();
    } else {
      clearDropdownState();
    }

    if (wasMenuOpen) {
      unlockPageScroll();
    }
  };

  const toggleMenu = () => {
    if (!isMobileMenuMode()) {
      closeMenu({ resetDropdownStyles: true });
      return;
    }

    if (headerComponent.classList.contains('is-open-menu')) {
      closeMenu();
      return;
    }

    openMenu();
  };

  dropdownItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      showDesktopDropdown(item);
    });

    item.addEventListener('mouseleave', () => {
      scheduleDesktopDropdownClose(item);
    });
  });

  dropdownToggles.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      const menuItem = this.closest('.menu-item.dropdown');
      const dropdownMenu = this.nextElementSibling;

      if (!menuItem || !dropdownMenu) {
        return;
      }

      if (!isMobileMenuMode()) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      const isAlreadyActive = menuItem.classList.contains('active');

      dropdownItems.forEach((item) => {
        if (item !== menuItem) {
          closeDropdown(item);
        }
      });

      if (isAlreadyActive) {
        closeDropdown(menuItem);
        return;
      }

      openDropdown(menuItem, dropdownMenu);
    });
  });

  if (burgerBtn) {
    burgerBtn.addEventListener('click', toggleMenu);
    burgerBtn.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') {
        return;
      }

      e.preventDefault();
      toggleMenu();
    });
  }

  headerCloseWrapper?.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && headerComponent.classList.contains('is-open-menu')) {
      closeMenu();
    }
  });

  const handleViewportChange = () => {
    const mobileMenuMode = isMobileMenuMode();

    if (!mobileMenuMode) {
      cancelDesktopDropdownClose();
      closeMenu({ resetDropdownStyles: true });
    } else if (!wasMobileMenuMode) {
      resetDropdownState();
    } else {
      updateActiveDropdownHeights();
    }

    wasMobileMenuMode = mobileMenuMode;
  };

  window.addEventListener('resize', handleViewportChange);
  window.addEventListener('orientationchange', handleViewportChange);

  function headerSticky() {
    let prevScrollPos = window.scrollY;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const headerHeight = headerComponent.scrollHeight;

      if (currentScrollPos > 100) {
        if (prevScrollPos > currentScrollPos) {
          headerComponent.style.top = window.innerWidth > 768 ? '0' : '0';
          headerComponent.classList.add('scrolled');
        } else {
          headerComponent.style.top = `-${headerHeight + 3}px`;
        }
      } else {
        headerComponent.style.top = '0';
        if (currentScrollPos === 0) {
          headerComponent.classList.remove('scrolled');
        } else {
          headerComponent.classList.add('scrolled');
        }
      }

      prevScrollPos = currentScrollPos;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  headerSticky();
}
